export default __webpack_public_path__ + "static/media/myclassic6.24a882f8.png";